let CLIENTE_RACK = 1;
let CABEAMENTO_MESH = 3;
let MANUTENCAO_PREV_INDOOR = 4;
let MANUTENCAO_REPARO_DROP = 5;
let VISITA_TECNICA_2 = 10;
let SUBST_CONTROLE_REMOTO = 11;
let TROCA_CONF_EQTO_STREAMING = 9;
let MANUTENCAO_INDOOR_GPON = 12;
let OS_MANUTENCAO = 13;
let LIMPEZA_RUIDO_INDOOR = 14;
let CONTROLE_QUALIDADE = 33;

export {
  CABEAMENTO_MESH,
  CLIENTE_RACK,
  LIMPEZA_RUIDO_INDOOR,
  MANUTENCAO_INDOOR_GPON,
  MANUTENCAO_PREV_INDOOR,
  MANUTENCAO_REPARO_DROP,
  OS_MANUTENCAO,
  SUBST_CONTROLE_REMOTO,
  TROCA_CONF_EQTO_STREAMING,
  VISITA_TECNICA_2,
  CONTROLE_QUALIDADE
};
